export default __webpack_public_path__ + "static/media/darkMobile.0443ae7d.svg";